import { render, staticRenderFns } from "./UserManagementIcon.vue?vue&type=template&id=dc192ce2"
import script from "./UserManagementIcon.vue?vue&type=script&lang=js"
export * from "./UserManagementIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports